import React from 'react';
import { useRangeSlider } from '../hooks/useRangeSlider';
import config from '../config/config';
import SearchFiltersNumeric from './generic/SearchFiltersNumeric';
import useRangeSliderData from '../hooks/useRangeSliderData';
import { useSearchStateFilters, useSearchStateFiltersDispatch } from '../hooks/useSearchStateFilters';

/*
    Filter for bathrooms
    Options: 2+ 3+ 4+, etc
    To cover all values, need to utilize 2 different algolia attributes min_bathrooms and max_bathrooms
        - useRangeSlider to get the min and max values for each attribute (but don't use it for the ui)
        - Get ranges of min values and max values in order to set filter string
*/
const SearchFilterBathrooms = () => {
	const dispatch = useSearchStateFiltersDispatch();
	const { bathrooms } = useSearchStateFilters();
	const minRangeSlider = useRangeSlider( { attribute: config.FILTER_ATTRIBUTES.bathMin, step: 1, precision: 1 } );
	const maxRangeSlider = useRangeSlider( { attribute: config.FILTER_ATTRIBUTES.bathMax, step: 1, precision: 1 } );
	const { isReady, ranges } = useRangeSliderData( { minRangeSlider, maxRangeSlider } );

	const onChange = ( { min = null, max = null } ) => {
		dispatch( {
			type: 'changed',
			bathrooms: { min, max },
		} );
	};

	if ( ! isReady ) {
		return null;
	}
	// console.log( 'bath', minRangeSlider, maxRangeSlider, ranges );
	return (
		<div>
			<SearchFiltersNumeric
				ranges={ranges}
				id="bathrooms"
				options={config.FILTER_OPTIONS_BATHROOM}
				onChange={onChange}
				label="Bathrooms"
				activeMin={bathrooms.min}
				activeMax={bathrooms.max}
			/>
		</div>
	);
};

export default SearchFilterBathrooms;

